import styled from "styled-components";
import { FieldGrid } from "../../../styles";

export const NewVariableArea = styled(FieldGrid)``;

export const CheckBoxManadatory = styled.div``;

export const DateRangeStart = styled.div`
	grid-column-start: 2;

	@media (max-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
		grid-column-start: auto;
	}
`;

export const AreaButton = styled.div`
	margin-top: 1rem;
	> button {
		margin-left: 0px;
		margin-right: 1rem;
	}
`;
